var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactGirlIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 336,
    viewBox: "0 0 303 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303 179.745C303 231.499 277.194 277.198 237.775 304.618C213.298 321.682 183.576 331.663 151.5 331.663C119.424 331.663 89.7018 321.682 65.225 304.618C25.8056 277.198 0 231.499 0 179.745C0 95.8495 67.8358 27.8496 151.5 27.8496C235.164 27.8496 303 95.8495 303 179.745Z",
    fill: "#00BA85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.806 161.232C208.046 163.884 164.686 164.709 164.686 164.709C164.686 164.709 93.0931 169.817 92.4269 144.946C91.9567 127.913 100.46 94.535 105.868 75.2037C108.356 66.3238 110.178 48.2694 110.178 43.1223C110.178 43.024 110.178 42.9258 110.178 42.8276C110.119 40.2147 110.374 37.7786 110.844 35.4997C114.43 15.3236 132.005 0 153.165 0C176.932 0 196.172 19.3117 196.172 43.1223C196.172 43.3187 196.172 43.4955 196.172 43.692C196.055 52.5915 197.25 61.4713 199.973 69.9386C200.189 70.6262 200.385 71.2549 200.561 71.8246C200.639 72.0407 200.698 72.2765 200.757 72.4926C209.006 100.213 218.626 159.012 213.786 161.212L213.806 161.232Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.073 65.9897C197.073 65.9897 220.605 102.236 217.098 149.543",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.092 196.516V313.27C203.519 327.611 178.538 336 151.578 336C124.618 336 99.637 327.611 79.0643 313.27V196.516C79.0643 157.244 104.712 115.988 143.859 115.988L159.259 113.336C198.425 113.336 224.092 157.244 224.092 196.516Z",
    fill: "#FFCA41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0643 313.27V196.516",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.092 313.27V196.516",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.097 217.753L120.523 238.616C120.523 238.616 144.133 237.693 150.364 230.738C154.4 226.22 162.159 224.511 172.543 221.092C179.91 218.676 180.439 213.529 177.226 211.544H177.598C179.009 210.759 180.713 209.403 180.948 207.478C181.223 205.219 180.517 203.824 178.93 203.254H179.283C179.283 203.254 180.439 200.209 179.361 198.441C178.656 197.301 177.598 196.201 174.737 195.828L175.266 195.199C175.266 195.199 175.835 188.559 169.408 188.264C162.981 187.97 152.989 190.504 146.484 193.412C139.979 196.319 136.609 200.288 132.553 205.081C128.478 209.875 114.156 217.753 114.156 217.753H114.097Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.227 195.219C175.227 195.219 175.795 188.579 169.369 188.284C162.942 187.989 152.95 190.524 146.445 193.431C139.94 196.339 136.57 200.307 132.514 205.101C128.439 209.894 114.116 217.772 114.116 217.772L120.543 238.636C120.543 238.636 144.152 237.713 150.383 230.758C154.419 226.24 162.178 224.53 172.562 221.112C182.927 217.713 179.792 208.853 171.661 211.132C171.661 211.132 162.648 213.313 158.024 215.926",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.52 202.586C150.52 202.586 160.277 196.85 168.33 195.966C176.383 195.082 178.244 196.712 179.342 198.461C180.439 200.229 179.263 203.274 179.263 203.274",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M154.811 209.914C154.811 209.914 162.139 205.612 174.953 203.176C179.263 202.37 181.379 203.824 180.948 207.478C180.713 209.403 179.028 210.759 177.598 211.564",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8452 180.524C69.3071 133.099 138.04 112.373 138.04 112.373L132.828 117.54C120.465 127.854 112.451 139.19 106.808 154.297L88.5279 203.195L54.7887 207.891L127.812 197.734L143.859 240.129C95.2287 294.646 40.6425 290.481 25.3207 277.318C9.99893 264.156 -5.1465 227.418 31.8452 180.563V180.524Z",
    fill: "#FFCA41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.079 112.412C138.079 112.412 69.307 133.08 31.8647 180.524C-5.14661 227.399 9.99882 264.116 25.3402 277.279C40.662 290.441 95.2482 294.626 143.878 240.09L127.831 197.694L54.8081 207.851",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2889 188.48L88.5278 203.175",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.186 200.524L126.068 201.801C124.736 201.86 123.501 201.152 122.816 199.934L97.5602 158.403C95.7772 154.867 98.7945 151.134 101.518 150.997L129.046 149.602C130.437 149.523 131.73 150.309 132.377 151.626L154.204 194.846C155.458 197.341 153.851 200.386 151.206 200.524H151.186Z",
    fill: "#D8DADE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.345 202.095L124.599 203.372C123.305 203.431 122.071 202.724 121.385 201.506L97.521 158.423C96.1299 155.928 97.717 152.725 100.401 152.588L127.518 151.193C128.87 151.115 130.163 151.9 130.81 153.217L152.323 196.437C153.557 198.932 151.97 201.977 149.364 202.115L149.345 202.095Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.768 165.279C106.906 165.279 106.122 164.808 105.711 164.061L103.752 160.427C102.909 158.855 104.026 156.969 105.809 156.969C106.671 156.969 107.455 157.441 107.866 158.187L109.825 161.822C110.668 163.393 109.551 165.279 107.768 165.279Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M155.046 192.017C150.971 187.223 147.62 183.255 141.116 180.347C134.611 177.44 124.618 174.905 118.192 175.2C111.765 175.495 112.333 182.135 112.333 182.135L112.862 182.764C110.002 183.137 108.944 184.218 108.238 185.377C107.141 187.145 108.317 190.19 108.317 190.19H108.669C107.102 190.76 106.397 192.154 106.651 194.414C106.886 196.339 108.571 197.694 110.002 198.5H110.374C107.161 200.445 107.67 205.592 115.057 208.008C125.422 211.407 133.18 213.136 137.236 217.654C143.467 224.589 167.076 225.532 167.076 225.532L173.503 204.669C173.503 204.669 159.161 196.791 155.105 191.997L155.046 192.017Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M112.314 182.135C112.314 182.135 111.746 175.495 118.172 175.2C124.599 174.905 134.591 177.44 141.096 180.347C147.601 183.255 150.971 187.223 155.027 192.017C159.102 196.81 173.425 204.688 173.425 204.688L166.998 225.552C166.998 225.552 143.388 224.629 137.158 217.674C133.122 213.156 125.363 211.446 114.979 208.028C104.614 204.629 107.749 195.769 115.88 198.048C115.88 198.048 124.893 200.229 129.517 202.842",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 189.502C137.04 189.502 127.283 183.765 119.23 182.881C111.178 181.997 109.316 183.628 108.219 185.376C107.122 187.145 108.297 190.19 108.297 190.19",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.749 196.849C132.749 196.849 125.422 192.547 112.608 190.111C108.297 189.306 106.181 190.759 106.612 194.413C106.847 196.339 108.532 197.694 109.963 198.5",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M271.135 178.677C233.673 131.253 164.941 110.526 164.941 110.526L168.722 113.67C181.085 123.984 190.549 137.343 196.192 152.431L214.472 201.329L248.211 206.024L175.188 195.867L159.141 238.263C207.771 292.779 262.357 288.614 277.679 275.452C293.001 262.289 308.146 225.552 271.155 178.697L271.135 178.677Z",
    fill: "#FFCA41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M164.96 110.526C164.96 110.526 233.693 131.253 271.155 178.677C308.166 225.552 293.021 262.27 277.679 275.432C262.357 288.595 207.771 292.779 159.141 238.243L175.188 195.848L248.211 206.004",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.711 186.654L214.472 201.329",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.172 118.365C170.035 124.239 161.571 128.797 151.265 128.581C140.959 128.345 132.71 123.414 132.828 117.54C132.965 111.666 141.429 107.108 151.735 107.324C162.041 107.56 170.29 112.491 170.172 118.365Z",
    fill: "#FFCA41",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M155.577 91.4552L149.073 91.311C143.253 91.182 138.43 95.8083 138.301 101.644L138.061 112.447C137.932 118.282 142.545 123.118 148.365 123.247L154.869 123.391C160.689 123.52 165.512 118.894 165.641 113.058L165.881 102.256C166.01 96.4197 161.397 91.5842 155.577 91.4552Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M147.304 12.5799L156.257 12.4608C171.479 12.2583 184.025 24.4889 184.227 39.7719L184.622 69.6308C184.824 84.8941 172.626 97.4735 157.384 97.6762L148.431 97.7953C133.208 97.9978 120.663 85.7671 120.461 70.4842L120.066 40.6253C119.864 25.362 132.061 12.7826 147.304 12.5799Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.943 73.2983C161.493 77.3846 158.083 80.6065 153.871 80.6655C149.658 80.7244 146.171 77.6007 145.603 73.5144L161.943 73.2983Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M135.257 54.6741C135.218 56.7369 133.533 58.3675 131.476 58.3282C129.419 58.289 127.792 56.5994 127.832 54.5366C127.871 52.4738 129.556 50.8432 131.613 50.8825C133.67 50.9218 135.297 52.6114 135.257 54.6741Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.581 53.7508C174.541 55.8136 172.856 57.4442 170.799 57.4049C168.742 57.3656 167.116 55.6761 167.155 53.6133C167.194 51.5505 168.879 49.9199 170.936 49.9592C172.993 49.9985 174.62 51.688 174.581 53.7508Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M166.959 45.6567C166.959 45.6567 172.19 44.3597 176.246 47.1699",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M135.003 46.4031C135.003 46.4031 129.713 45.342 125.814 48.3486",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.791 63.1609L149.051 63.2985L151.931 48.5249",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.983 49.6448C186.062 49.1733 185.18 48.6821 184.338 48.1517C170.642 39.6451 164.529 23.6143 164.529 23.6143C159.082 43.0045 133.905 48.8786 120.21 50.6664C114.861 51.354 110.237 45.5192 110.198 42.8474C110.139 40.2345 110.394 37.7984 110.864 35.5195C115.174 15.1863 138.804 7.937 153.538 7.28869C171.583 6.48322 178.558 10.0194 184.906 21.6497C191.254 33.2996 187.003 49.6644 187.003 49.6644L186.983 49.6448Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M137.001 49.9591C137.001 49.9591 161.12 47.3659 164.51 23.6143",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactGirlIc);
export default __webpack_public_path__ + "static/media/contactGirl_ic.e9da148c.svg";
export { ForwardRef as ReactComponent };